import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebases"; // 確保路徑正確
import PropTypes from "prop-types";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("Setting up onAuthStateChanged");
    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {
        // console.log("onAuthStateChanged triggered:", currentUser);
        setUser(currentUser);
        setLoading(false);
      },
      (error) => {
        console.error("onAuthStateChanged error:", error);
        setLoading(false);
      }
    );

    return () => {
      console.log("Cleaning up onAuthStateChanged");
      unsubscribe();
    };
  }, []);

  const logout = () => {
    signOut(auth).then(() => {
      // 登出時清除 sessionStorage 中的 role
      sessionStorage.removeItem("userRole");
      sessionStorage.removeItem("userRawRole");
      // 可選：清除其他持久化狀態
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("hierarchyData");
      sessionStorage.removeItem("posPidArray");
    });
  };

  return <AuthContext.Provider value={{ user, logout, loading }}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useAuth() {
  return useContext(AuthContext);
}
